import { render, staticRenderFns } from "./Caption.vue?vue&type=template&id=54a20d7c&scoped=true"
import script from "./Caption.vue?vue&type=script&lang=js"
export * from "./Caption.vue?vue&type=script&lang=js"
import style0 from "./Caption.vue?vue&type=style&index=0&id=54a20d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a20d7c",
  null
  
)

export default component.exports